/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import can from 'can';
import BaseControl from 'scripts/base-control';
import DomEventsManager from 'scripts/dom-events-manager';
import view from './course-map.stache';

const holeDetailLink = _.get(
    window,
    'globalSettings.pagePaths.holeDetail',
    '/course/{holeId}.html',
);

export const CourseMap = BaseControl.extend({
    init() {
        this._super();
        this.$element.append(
            view(
                new can.Map({
                    holeByHoleLink: can.sub(holeDetailLink, { holeId: 1 }),
                    pins: this.generatePins(),
                    pinImage: this.options.pinImage,
                    image: {
                        type: 'imageCloudinary',
                        identifier: 'course-map-2022.png',
                        cropMode: 'crop',
                        gravity: 'center',
                    },
                    courseTitle: this.options.courseTitle,
                    getHoleLink(number) {
                        return can.sub(holeDetailLink, { holeId: number });
                    },
                }),
            ),
        );
    },

    generatePins() {
        const pins = _.range(1, 19).map((v) => ({ number: v }));

        pins[9].borderPosition = 'left';
        pins[13].borderPosition = 'right';
        pins[14].borderPosition = 'right';
        pins[15].borderPosition = 'right';
        pins[16].borderPosition = 'right';

        return pins;
    },
});
